$(function(){

	var app = app || {};
	app.debug = false;

	var getBrowser = function(){
	var ua = window.navigator.userAgent.toLowerCase();
	var ver = window.navigator.appVersion.toLowerCase();
	var name = 'unknown';

	if (ua.indexOf("msie") != -1){
			if (ver.indexOf("msie 6.") != -1){
				name = 'ie6';
			}else if (ver.indexOf("msie 7.") != -1){
				name = 'ie7';
			}else if (ver.indexOf("msie 8.") != -1){
				name = 'ie8';
			}else if (ver.indexOf("msie 9.") != -1){
				name = 'ie9';
			}else if (ver.indexOf("msie 10.") != -1){
				name = 'ie10';
			}else{
				name = 'ie';
			}
		}else if(ua.indexOf('trident/7') != -1){
			name = 'ie11';
		}else if (ua.indexOf('chrome') != -1){
			name = 'chrome';
		}else if (ua.indexOf('safari') != -1){
			name = 'safari';
		}else if (ua.indexOf('opera') != -1){
			name = 'opera';
		}else if (ua.indexOf('firefox') != -1){
			name = 'firefox';
		}
		return name;
	};


	app.iPhone = false;
	app.smtTablet = false;

	var userAgent = window.navigator.userAgent.toLowerCase();

	if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
		app.iPhone = true;
		$(".panel,.half_panel").css({"transform": "translateY(0px) rotateY(0deg)"});
		$(".panel,.half_panel").addClass('show');
	}
	if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0 || navigator.userAgent.indexOf('Mobile') > 0){
		app.smtTablet = true;
	}


	app.OldIE=false;
	var name = getBrowser();
	if(name=="ie6" || name=="ie7" || name=="ie8" || name=="ie9"){
		app.OldIE = true;
		$("body").addClass('old_ie');
	}


	var question_pane=[];
	var questionnaire_txt_scroll = function( _destroy ){

		if( _destroy ){
			$('.clone .questionnaire').each(function(index, el) {
				$(el).jScrollPane().data().jsp.destroy();
			});
		}else{

			if($(window).width()<780){
				questionnaire_txt_scroll(true);
			} if(780 <= $(window).width()){
				questionnaire_txt_scroll(true);
			}
		}
	}
	if(!app.OldIE){
		//questionnaire_txt_scroll();
	}



	//詳細ボタンを複製

	$("#detail_sauce .slide").each(function(index, el) {
		$(el).append($('#ctrl_btns').html());

		if( index == 0 ){
			$(el).find(".prev_btn").hide();
		}else if( index == $("#detail_sauce .slide").length-1 ){
			$(el).find(".next_btn").hide();
		}

		$(el).find(".profile li").each(function(index2, _el) {
			if( $(_el).find(".tl").text() == "" ){
				$(_el).addClass('no_dot');
			}
		});




	});
	$("#detail_sauce .slide").width($(window).width());
	function fWinHeight(){
		return $("#detail_sp_bottom").offset().top+10-$(window).scrollTop();
	}

/*


______  ___   _   _  _____ _     
| ___ \/ _ \ | \ | ||  ___| |    
| |_/ / /_\ \|  \| || |__ | |    
|  __/|  _  || . ` ||  __|| |    
| |   | | | || |\  || |___| |____
\_|   \_| |_/\_| \_/\____/\_____/


*/




	app.scrollTop = 0;
	app.detail_page_id = 1;

	// パネルをクリック
	var _vscroll = 0;
	$(" .panel , .half_panel ").on("click",function(e){
		e.preventDefault();
		app.detail_page_id = $(this).data("id");

		if( app.detail_page_id == 13 || app.detail_page_id == 14 ){
			if(app.detail_page_id==13){
				window.open( "http://www.jleague.jp/", "_blank" );
			}
			if(app.detail_page_id==14){
				window.open( "http://www.kamatamare.jp/", "_blank" );
			}
		}else{
		app.scrollTop = $(window).scrollTop();
		
		$(this).addClass('open');

		$('#detail').append( $( '#detail_sauce .slide' + app.detail_page_id ).clone().addClass('clone') );
		setTimeout( function(){ $("#detail , #detail .clone").height(fWinHeight()); } , 50 );
		$("#detail , #detail .clone").height(fWinHeight());
		$("#detail .clone").css({top: fWinHeight()});
		$("#detail , #detail .clone").addClass('show');
		if(!app.smtTablet){$("body").addClass('opneDetail');};
		$("#detail , #detail_sauce .slide , #detail .slide").width($(window).width());
		detailScrolls();

		if(!app.OldIE){
			cloneMousewheel();
			TweenMax.to('#detail .clone', !app.smtTablet ? 1.0 : 0.4, {
					top:0,
					ease: Expo.easeInOut,
					startAt: {
						top: fWinHeight()
					},
					onComplete: function(){
						$("#site-header , #head , #what , #list , #site-footer").hide();
						$("#rss").css("visibility", "hidden");
						
						if(app.smtTablet){
							setTimeout( function(){ $("#detail , #detail .clone").height(fWinHeight()); } , 200 );
							$("#detail .clone").addClass('smooth');
						}
					}
			});
		}else{
			$('#detail .clone').css("top",$(window).height()).animate(
				{top: 0 },
				{duration: 500, easing: "easeOutCubic",
					complete: function(){
						$("#site-header , #head , #what , #list , #site-footer").hide();
						$("#rss").css("visibility", "hidden");
					}
				}
			)
		}
		}
	});

	//詳細移動ボタン →
	$(document).on("click","#detail .next_btn",function(e){
		e.preventDefault();

		var old_detail_page_id = app.detail_page_id

		//ノーマル
		//app.detail_page_id = app.detail_page_id+1;
		if(app.detail_page_id == 6){
			app.detail_page_id = 8;
		}else{
			app.detail_page_id = app.detail_page_id+1;
		}

		$('#detail').prepend( $('#detail_sauce  .slide'+app.detail_page_id ).clone().addClass('clone') );

		$('#detail_sauce .clone.slide'+app.detail_page_id).jScrollPane({mouseWheelSpeed : 10});
		$("#detail , #detail .clone").addClass('moving');
		$("#detail , #detail .clone").height(fWinHeight());
		$("#detail .clone").width($(window).width());
		
		$("#list .panel,#list .half_panel").removeClass('open');
		$('#list panel_'+app.detail_page_id).addClass('open');

		detailScrolls();
		if(!app.OldIE){
			cloneMousewheel();
			TweenMax.to('#detail .clone.slide'+old_detail_page_id , !app.smtTablet ? 0.9 : 0.5 , {
					"left":-$(window).width(),
					ease: Expo.easeInOut,
					startAt: {
						"left": 0
					},
					onComplete: function(){
						if(app.smtTablet){
							$("#detail .clone").addClass('smooth');
						}
					}
			});
			TweenMax.to('#detail .clone.slide'+app.detail_page_id , !app.smtTablet ? 0.9 : 0.5 , {
					"left":0,
					ease: Expo.easeInOut,
					startAt: {
						"left": $(window).width()
					},
					onComplete: function(){
						$('#detail .clone.slide'+old_detail_page_id +" .questionnaire" ).jScrollPane().data().jsp.destroy();
						$('#detail .clone.slide'+old_detail_page_id ).remove();
						$("#detail , #detail .clone").removeClass('moving');
					}
			});
		}else{
			$("#detail , #detail .clone").height($(window).height());
			$('#detail .clone.slide'+old_detail_page_id).css("left",0).animate(
				{"left": -$(window).width()},
				{duration: 900, easing: "easeOutCubic"}
			)
			$('#detail .clone.slide'+app.detail_page_id).css("left",$(window).width()).animate(
				{"left": 0},
				{duration: 900, easing: "easeOutCubic",
					complete: function(){
						$('#detail .clone.slide'+old_detail_page_id +" .questionnaire" ).jScrollPane().data().jsp.destroy();
						$('#detail .clone.slide'+old_detail_page_id ).remove();
						$("#detail , #detail .clone").removeClass('moving');
					}
				}
			)
		}
	});

	//詳細移動ボタン ←
	$(document).on("click","#detail .prev_btn",function(e){
		e.preventDefault();

		var old_detail_page_id = app.detail_page_id

		//ノーマル
		//app.detail_page_id = app.detail_page_id-1;
		if(app.detail_page_id == 8){
			app.detail_page_id = 6;
		}else{
			app.detail_page_id = app.detail_page_id-1;
		}

		$('#detail').prepend( $('#detail_sauce .slide'+app.detail_page_id ).clone().addClass('clone') );
		$('#detail_sauce .clone.slide'+app.detail_page_id).jScrollPane({mouseWheelSpeed : 10});
		$("#detail , #detail .clone").addClass('moving');
		$("#detail , #detail .clone").height(fWinHeight());
		$("#detail .clone").width($(window).width());

		$("#list .panel,#list .half_panel").removeClass('open');
		$('#list panel_'+app.detail_page_id).addClass('open');

		detailScrolls();
		if(!app.OldIE){
			cloneMousewheel();
			TweenMax.to('#detail .clone.slide'+old_detail_page_id , !app.smtTablet ? 0.9 : 0.5 , {
					"left":$(window).width(),
					ease: Expo.easeInOut,
					startAt: {
						"left": 0
					},
					onComplete: function(){
						if(app.smtTablet){
							$("#detail .clone").addClass('smooth');
						}
					}
			});
			TweenMax.to('#detail .clone.slide'+app.detail_page_id , !app.smtTablet ? 0.9 : 0.5 , {
					"left":0,
					ease: Expo.easeInOut,
					startAt: {
						"left": -$(window).width()
					},
					onComplete: function(){
						$('#detail .clone.slide'+old_detail_page_id +" .questionnaire" ).jScrollPane().data().jsp.destroy();
						$('#detail .clone.slide'+old_detail_page_id ).remove();
						$("#detail , #detail .clone").removeClass('moving');
					}
			});
		}else{
			$("#detail , #detail .clone").height($(window).height());
			$('#detail .clone.slide'+old_detail_page_id).css("left",0).animate(
				{"left": $(window).width()},
				{duration: 900, easing: "easeOutCubic"}
			)
			$('#detail .clone.slide'+app.detail_page_id).css("left",-$(window).width()).animate(
				{"left": 0},
				{duration: 900, easing: "easeOutCubic",
					complete: function(){
						$('#detail .clone.slide'+old_detail_page_id +" .questionnaire" ).jScrollPane().data().jsp.destroy();
						$('#detail .clone.slide'+old_detail_page_id ).remove();
						$("#detail , #detail .clone").removeClass('moving');
					}
				}
			)
		}
	});

	//詳細閉じるボタン X
	$(document).on("click","#detail .close_detail_btn",function(e){
		e.preventDefault();
		$("#site-header , #head , #what , #rss , #list , #site-footer").show();
		$("#rss").css("visibility", "visible");
		
		$(window).scrollTop(app.scrollTop);
		if(!app.OldIE){
			TweenMax.to('#detail .clone', 0.5, {
				top:$(window).height(),
				ease: Expo.easeInOut,
				startAt: {top: 0},
				delay:0.3,
				onComplete: function(){
					$("#detail , #detail .slide.clone ").removeClass('show');
					$("#detail .clone").remove();
					$("#detail").height(0);
					$("body").removeClass('opneDetail');
					$(" .panel , .half_panel ").removeClass('open');
				}
			});
		}else{
			$('#detail .clone').animate(
				{top: $(window).height()},
				{duration: 500, easing: "easeOutCubic",
					complete: function(){
						$("#detail , #detail .clone .questionnaire").jScrollPane().data().jsp.destroy();
						$("#detail , #detail .clone ").removeClass('show');
						$("#detail .clone").remove();
						$("#detail").height(0);
						$("body").removeClass('opneDetail');
						$(" .panel , .half_panel ").removeClass('open');
					}
				}
			)
		}
	});


	if(!app.OldIE){
		if(!app.smtTablet){
			var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

			var scrolly = 0;
			var scrolly_slide = 0;

			var speed = 180;
			var animespeed = 500;
			$('html , body').on("mousewheel", function(event, mov) {
				if (mov > 0){
					scrolly =  $(window).scrollTop() - speed;
				} else if (mov < 0){
					scrolly =  $(window).scrollTop() + speed;
				}
				$(' html , body').stop(false,false).animate({ "scrollTop": scrolly }, animespeed ,"easeOutQuad");
				return false;
			});
		}
	}


	function cloneMousewheel(){
		var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
		/*$('#detail .clone').on("mousewheel" , function(event, mov) {
			if (mov > 0){
				scrolly_slide =  $(this).scrollTop() - speed;
			} else if (mov < 0){
				scrolly_slide =  $(this).scrollTop() + speed;
			}
			$( '#detail .clone').stop(false,false).animate({ "scrollTop": scrolly_slide }, animespeed ,"easeOutQuad");
			return false;
		});*/
	}

	//
	app.ie8QuestionnaireTimeOut;
	app.ie8QuestionnaireTimeOut2;

	function detailScrolls(){
		$("#detail").width($(window).width());
		$("#detail .clone").width($(window).width());
		if(!app.OldIE){
			if( 790 < $(window).width()){
				clearTimeout( app.ie8QuestionnaireTimeOut );
				app.ie8QuestionnaireTimeOut = setTimeout( function(){
					$('#detail .clone .questionnaire').jScrollPane({mouseWheelSpeed : 10});
				} , 500 );
			}else{
				clearTimeout( app.ie8QuestionnaireTimeOut2 );
				app.ie8QuestionnaireTimeOut2 = setTimeout( function(){
					$('#detail .clone').each(function(index, el) {
						$(el).find('.questionnaire').jScrollPane().data().jsp.destroy();
					});
				} , 100 );
			}

			//詳細全体スクロール
			if(!app.smtTablet){
				if($(window).width() < 1020){
					$("#detail .clone").niceScroll({cursoropacitymax:"0.5",cursorwidth:5});
				}else{
					$("#detail .clone").getNiceScroll().remove();
				}
			}
		}else{
			if( 790 < $(window).width()){
				clearTimeout( app.ie8QuestionnaireTimeOut );
				app.ie8QuestionnaireTimeOut = setTimeout( function(){
					$('#detail .clone .questionnaire').jScrollPane({mouseWheelSpeed : 10});
				} , 500 );
			}else{
				clearTimeout( app.ie8QuestionnaireTimeOut2 );
				app.ie8QuestionnaireTimeOut2 = setTimeout( function(){
					$('#detail .clone').each(function(index, el) {
						$(el).find('.questionnaire').jScrollPane().data().jsp.destroy();
					});
				} , 100 );
			}
		}

		$("#rss").height(($("#rss .bx-wrapper").height()));
	}






	/*
	___  ___ _____ _   _ _   _ 
	|  \/  ||  ___| \ | | | | |
	| .  . || |__ |  \| | | | |
	| |\/| ||  __|| . ` | | | |
	| |  | || |___| |\  | |_| |
	\_|  |_/\____/\_| \_/\___/ 

	メニューを縮める

	*/

	if(!app.OldIE){

		// タイムライン作る
		var tl = new TimelineMax();

		// idがmoveのtopを250pxにする動作を0秒後に呼ぶ
		TweenMax.set('#head', {
			height:$(window).height()-$("#site-header").height(),
			onComplete: function(){
				$("#head dl").addClass('show');
			}
		});
		tl.add(TweenMax.to("#head" , 0.5 , {
			onStart: function(){
			},
			height:300,
			ease:Circ.easeOut,
			onComplete: function(){
			}
		}), 3);
	}else{
		$("#head").css({height:$(window).height()-$("#site-header").height()});
		$("#head dt,#head dd").delay(400).animate(
			{opacity: 1},
			{duration: 400, easing: "linear",
				complete: function(){},
				step: function(s){}
			}
		);
		$("#head").delay(3000).animate(
			{height: 300},
			{duration: 500, easing: "easeOutCubic"}
		)
	}


	/*
	______  _____ _____ 
	| ___ \/  ___/  ___|
	| |_/ /\ `--.\ `--. 
	|    /  `--. \`--. \
	| |\ \ /\__/ /\__/ /
	\_| \_|\____/\____/ 

	RSS

	*/

	app.rss_slider;

	app.rss_sliderSize = function(){
		$("#rss .slide .img").each(function(index, el) {
			if( 0 < $(el).find("img").length ){

				if($(el).find("img").height() < $(el).find("img").width()){
					$(el).find("img").css("width","100%");
				}else{

					$(el).find("img").css({
						"width":"auto",
						"height":"auto"
					});

					var _nw = $(el).find("img").width();
					var _nh = $(el).find("img").height();

					$(el).find("img").css({
						"width":"100%",
						"height":"100%"
					});

					var _sw = $(el).find("img").width();
					var _sh = $(el).find("img").height();
					var _size = (_sh/_nh)*_nw;

					$(el).find("img").css({
						"width": _size,
						"height": "100%"
					});
				}
			}
		});
	}

	$("#rss .slide").each(function(index, el) {
		if( 0 < $(el).find("a").length){
			$(el).addClass('have_link')
		}
	});


	$(document).on("click","#rss .slide",function(){
		if($(this).hasClass('have_link')){
			var _href = $(this).find("a").attr("href");
			var _target = $(this).find("a").attr("target");
			window.open( _href , _target );
		}
	})

	app.rss_panel = function ( _val ){
		var w = ($(window).width()/100)*_val;
		if(255 < w){
			return 255;
		}else{
			return w;
		}
	}

	var fRSS = function(){
		try{
			app.rss_slider.destroySlider();
		}catch( e ){
		}
		
		//RSSスクロール
		if($(window).width()<520){
			$('#rss').addClass('s_size').removeClass('m_size').removeClass('l_size');
			app.rss_slider = $('#rss .bxslider_rss').bxSlider({
				slideWidth: app.rss_panel(75),
				minSlides: 1,
				maxSlides: 1,
				moveSlides: 1,
				auto:true,
				pager:false,
				slideMargin:14,
			});
		}if(520 <= $(window).width() && $(window).width()<780){
			$('#rss').addClass('m_size').removeClass('s_size').removeClass('l_size');
			//RSSスクロール
			app.rss_slider = $('#rss .bxslider_rss').bxSlider({
				slideWidth: app.rss_panel(40),
				minSlides: 2,
				maxSlides: 2,
				moveSlides: 1,
				auto:true,
				pager:false,
				slideMargin:14,
			});
		} if(780 <= $(window).width() && $(window).width()<1020){
			$('#rss').addClass('m_size').removeClass('s_size').removeClass('l_size');
			//RSSスクロール
			app.rss_slider = $('#rss .bxslider_rss').bxSlider({
				slideWidth: app.rss_panel(27),
				minSlides: 3,
				maxSlides: 3,
				moveSlides: 1,
				auto:true,
				pager:false,
				slideMargin:14,
			});
		}else if(1020<=$(window).width()){
			$('#rss').addClass('l_size').removeClass('s_size').removeClass('m_size');
			//RSSスクロール
			app.rss_slider = $('#rss .bxslider_rss').bxSlider({
				slideWidth: app.rss_panel(18),
				minSlides: 4,
				maxSlides: 4,
				moveSlides: 1,
				auto:true,
				pager:false,
				slideMargin:14,
			});
		}
		$("#rss").height(($("#rss .bx-wrapper").height()));

		app.rss_sliderSize();



	}

	fRSS();

	/*
	  __ 
	 / _|
	| |_ ___   ___ _   _ ___ 
	|  _/ _ \ / __| | | / __|
	| || (_) | (__| |_| \__ \
	|_| \___/ \___|\__,_|___/
	
	フォーカス
	*/


	$(window).on("focus",function(){
		//ウィンドウがアクティブになったのでアニメーションを設定しました。
		$(".opneDetail #detail , #detail .slide").height(fWinHeight());
	}).on("blur",function(){
		//フォーカスが外れました。アニメーションを解除しました
	 });

	/*
	______ _____ _____ _____ ______ _____ 
	| ___ \  ___/  ___|_   _|___  /|  ___|
	| |_/ / |__ \ `--.  | |    / / | |__  
	|    /|  __| `--. \ | |   / /  |  __| 
	| |\ \| |___/\__/ /_| |_./ /___| |___ 
	\_| \_\____/\____/ \___/\_____/\____/ 
	
	ウィンドウがリサイズされたら反応 ※リサイズ操作が終わった時にだけ
	*/

	var resizeTime1 = false;
	$(window).on('resize',window,function(event){
			if (resizeTime1 !== false) {
				clearTimeout(resizeTime1);
			}
			resizeTime1 = setTimeout(function() {
				fRSS();
				PanelChange();
				detailScrolls();
				fIE8detail_question();
		 }, 100);

		$(".opneDetail #detail .slide").width($(window).width());
		$(".opneDetail #detail ,.opneDetail #detail .slide").height(fWinHeight());
	});
	$(" .opneDetail #detail , .opneDetail #detail .slide").height(fWinHeight());

	//
	function PanelChange(){
		if($(window).width()<520){
			$(".panel_4 .panel").prepend($(".panel_4 .panel dt"));
			$(".panel_8 .panel").prepend($(".panel_8 .panel dt"));
			$(".panel_10 .panel").prepend($(".panel_10 .panel dt"));
			$(".panel_12 .panel").prepend($(".panel_12 .panel dt"));
		}else{
			$(".panel_4 .panel").append($(".panel_4 .panel dt"));
			$(".panel_8 .panel").append($(".panel_8 .panel dt"));
			$(".panel_10 .panel").append($(".panel_10 .panel dt"));
			$(".panel_12 .panel").append($(".panel_12 .panel dt"));
		}
	}
	PanelChange();

	//
	function fIE8detail_question(){
		if(app.OldIE){
			if( 1020 < $(window).width()){
				$("#detail .info_wrap .txt").width(650);
				$("#detail .info_wrap .img").css({"width":"30%"});
				$("#detail .info_wrap .profile").css({
					"width": 186,
					"margin-bottom": "auto"
				});
			}else{
				$("#detail .info_wrap .txt").width(350);
				$("#detail .info_wrap .img").css({"width":"43.7%"});
				$("#detail .info_wrap .profile").css({
					"width": "95%",
					"margin-bottom": 15
				});
			}
		}
	}

	/*
	 _____ _____ ______ _____ _      _     
	/  ___/  __ \| ___ \  _  | |    | |    
	\ `--.| /  \/| |_/ / | | | |    | |    
	 `--. \ |    |    /| | | | |    | |    
	/\__/ / \__/\| |\ \\ \_/ / |____| |____
	\____/ \____/\_| \_|\___/\_____/\_____/

	スクロール

	*/

	//
	function f_removeIndicators( _scene ){
		if(!app.debug){
			_scene.removeIndicators();
		}
	}

	if(!app.OldIE && !app.iPhone){

		// 全体を制御するコントローラをつくります
		var controller = new ScrollMagic.Controller();

		var scene1 = new ScrollMagic.Scene({
			triggerElement: ".panel_1" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_1 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_1 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_1 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_1 .panel").addClass('show');
		})
		.setTween(".panel_1 .panel", 1, { transform:"translateY(0)", rotationY: 0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 1"})
		.addTo(controller);
		f_removeIndicators(scene1);

		//
		var scene2 = new ScrollMagic.Scene({
			triggerElement: ".panel_2_3" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_2_3 .panel_2").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_2").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_2").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_2").addClass('show');
		})
		.setTween(".panel_2_3 .panel_2", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 2"})
		.addTo(controller);
		f_removeIndicators(scene2);

		//
		var scene3 = new ScrollMagic.Scene({
			triggerElement: ".panel_2_3",
			offset: $(window).height()/5,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_2_3 .panel_3").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_3").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_3").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_3").addClass('show');
		})
		.setTween(".panel_2_3 .panel_3", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 3"})
		.addTo(controller);
		f_removeIndicators(scene3);



		var scene4 = new ScrollMagic.Scene({
			triggerElement: ".panel_4" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_4 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_4 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_4 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_4 .panel").addClass('show');
		})
		.setTween(".panel_4 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 4"})
		.addTo(controller);
		f_removeIndicators(scene4);







		//
		var scene5 = new ScrollMagic.Scene({
			triggerElement: ".panel_5_6" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_5_6 .panel_5").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_5").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_5").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_5").addClass('show');
		})
		.setTween(".panel_5_6 .panel_5", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 5"})
		.addTo(controller);
		f_removeIndicators(scene5);



		//
		var scene6 = new ScrollMagic.Scene({
			triggerElement: ".panel_5_6",
			offset: $(window).height()/5,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_5_6 .panel_6").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_6").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_6").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_6").addClass('show');
		})
		.setTween(".panel_5_6 .panel_6", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 6"})
		.addTo(controller);
		f_removeIndicators(scene6);

		//
		var scene7 = new ScrollMagic.Scene({
			triggerElement: ".panel_7" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_7 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_7 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_7 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_7 .panel").addClass('show');
		})
		.setTween(".panel_7 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 7"})
		.addTo(controller);
		f_removeIndicators(scene7);






		var scene8 = new ScrollMagic.Scene({
			triggerElement: ".panel_8" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_8 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_8 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_8 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_8 .panel").addClass('show');
		})
		.setTween(".panel_8 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 8"})
		.addTo(controller);
		f_removeIndicators(scene8);





		var scene9 = new ScrollMagic.Scene({
			triggerElement: ".panel_9" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_9 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_9 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_9 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_9 .panel").addClass('show');
		})
		.setTween(".panel_9 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 9"})
		.addTo(controller);
		f_removeIndicators(scene9);



		var scene10 = new ScrollMagic.Scene({
			triggerElement: ".panel_10" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_10 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_10 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_10 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_10 .panel").addClass('show');
		})
		.setTween(".panel_10 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 10"})
		.addTo(controller);
		f_removeIndicators(scene10);





		//
		var scene11 = new ScrollMagic.Scene({
			triggerElement: ".panel_11" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_11 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_11 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_11 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_11 .panel").addClass('show');
		})
		.setTween(".panel_11 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 11"})
		.addTo(controller);
		f_removeIndicators(scene11);





		//
		var scene12 = new ScrollMagic.Scene({
			triggerElement: ".panel_12" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_12 .panel").show();
		})
		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_12 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_12 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_12 .panel").addClass('show');
		})
		.setTween(".panel_12 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 12"})
		.addTo(controller);
		f_removeIndicators(scene12);




		//
		var scene13 = new ScrollMagic.Scene({
			triggerElement: ".panel_13" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_13 .panel").show();
		})

		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_13 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_13 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_13 .panel").addClass('show');
		})
		.setTween(".panel_13 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 13"})
		.addTo(controller);
		f_removeIndicators(scene13);


		var scene14 = new ScrollMagic.Scene({
			triggerElement: ".panel_14" ,
			duration: $(window).height()/3 ,
			triggerHook: "onEnter" ,
			reverse: true ,
			loglevel: 0
		})
		.on("enter", function (e) {
			$(".panel_14 .panel").show();
		})

		.on("progress", function (e) {
			if(e.scrollDirection=="REVERSE"){
				$(".panel_14 .panel").removeClass('show');
			}
		})
		.on("leave", function (e) {
			if(e.state=="BEFORE"){
				$(".panel_14 .panel").removeClass('show');
			}
		})
		.on("end", function (e) {
			$(".panel_14 .panel").addClass('show');
		})
		.setTween(".panel_14 .panel", 1, { transform:"translateY(0)", rotationY: 0, paddingTop:0, ease: Sine.easeInOut})
		.addIndicators({name: "PANEL 14"})
		.addTo(controller);
		f_removeIndicators(scene14);

	}





});


